export const socialPlatforms = [
  {
    name: 'Instagram',
    icon: 'ri-instagram-line',
    followers: 12400,
    engagementRate: 4.2,
    postFrequency: 5,
    healthScore: 78,
    trend: 'up',
    trendValue: 12,
    status: 'strong',
    lastPost: '2 days ago',
  },
  {
    name: 'LinkedIn',
    icon: 'ri-linkedin-box-line',
    followers: 8900,
    engagementRate: 2.8,
    postFrequency: 3,
    healthScore: 65,
    trend: 'up',
    trendValue: 8,
    status: 'moderate',
    lastPost: '5 days ago',
  },
  {
    name: 'Twitter / X',
    icon: 'ri-twitter-x-line',
    followers: 5400,
    engagementRate: 1.5,
    postFrequency: 8,
    healthScore: 42,
    trend: 'down',
    trendValue: -15,
    status: 'weak',
    lastPost: '1 week ago',
  },
  {
    name: 'Facebook',
    icon: 'ri-facebook-circle-line',
    followers: 3200,
    engagementRate: 1.2,
    postFrequency: 2,
    healthScore: 35,
    trend: 'down',
    trendValue: -22,
    status: 'weak',
    lastPost: '12 days ago',
  },
  {
    name: 'YouTube',
    icon: 'ri-youtube-line',
    followers: 2100,
    engagementRate: 3.5,
    postFrequency: 1,
    healthScore: 58,
    trend: 'up',
    trendValue: 5,
    status: 'moderate',
    lastPost: '1 week ago',
  },
];

export const engagementHistory = [
  { month: 'Jan', instagram: 3.8, linkedin: 2.5, twitter: 2.1, facebook: 1.8, youtube: 3.2 },
  { month: 'Feb', instagram: 4.0, linkedin: 2.3, twitter: 1.9, facebook: 1.5, youtube: 3.0 },
  { month: 'Mar', instagram: 4.1, linkedin: 2.6, twitter: 1.7, facebook: 1.3, youtube: 3.1 },
  { month: 'Apr', instagram: 3.9, linkedin: 2.7, twitter: 1.6, facebook: 1.2, youtube: 3.4 },
  { month: 'May', instagram: 4.2, linkedin: 2.8, twitter: 1.5, facebook: 1.2, youtube: 3.5 },
];

export const communicationDirection = {
  brandVoice: {
    tone: 'Professional yet approachable',
    personality: 'Innovative, helpful, confident',
    guidelines: [
      'Use clear, jargon-free language',
      'Lead with value, not product features',
      'Balance authority with warmth',
      'Avoid overly promotional language',
    ],
  },
  platformDirections: [
    {
      platform: 'LinkedIn',
      icon: 'ri-linkedin-box-line',
      tone: 'Thought leadership, industry insights',
      style: 'Long-form articles, data-backed opinions, professional commentary',
      frequency: '3 posts per week',
      bestTime: 'Tue-Thu, 8-10 AM',
    },
    {
      platform: 'Instagram',
      icon: 'ri-instagram-line',
      tone: 'Visual storytelling, behind-the-scenes',
      style: 'Carousel tips, Reels for tutorials, Stories for quick updates',
      frequency: '5 posts per week',
      bestTime: 'Mon, Wed, Fri, 11 AM - 1 PM',
    },
    {
      platform: 'Twitter / X',
      icon: 'ri-twitter-x-line',
      tone: 'Concise, witty, conversational',
      style: 'Threads for deep dives, single tweets for quick takes',
      frequency: '8 posts per week',
      bestTime: 'Daily, 9-11 AM & 5-7 PM',
    },
    {
      platform: 'YouTube',
      icon: 'ri-youtube-line',
      tone: 'Educational, in-depth, tutorial',
      style: 'How-to videos, case studies, product walkthroughs',
      frequency: '1 video per week',
      bestTime: 'Sat, 10 AM - 12 PM',
    },
    {
      platform: 'Facebook',
      icon: 'ri-facebook-circle-line',
      tone: 'Community-focused, conversational',
      style: 'Event promotions, community polls, user-generated content',
      frequency: '2 posts per week',
      bestTime: 'Wed & Sat, 1-3 PM',
    },
  ],
  narrativeBehavior: [
    { phase: 'Awareness', behavior: 'Educate and inspire', contentTypes: ['Industry trends', 'Pain point education', 'Myth busting'] },
    { phase: 'Consideration', behavior: 'Prove and demonstrate', contentTypes: ['Case studies', 'Comparisons', 'Testimonials'] },
    { phase: 'Decision', behavior: 'Reassure and convert', contentTypes: ['Free trials', 'ROI calculators', 'FAQ content'] },
    { phase: 'Retention', behavior: 'Engage and reward', contentTypes: ['Tips & tricks', 'Exclusive updates', 'Community highlights'] },
  ],
  aiGenerationRules: [
    'Always open with a hook related to audience pain point',
    'Include one data point or statistic per post when relevant',
    'End with a clear call-to-action or conversation starter',
    'Match platform-specific character limits and formatting',
    'Use emojis sparingly and only on Instagram/Twitter',
    'Never use generic phrases like "In today\'s fast-paced world"',
  ],
};

export const audienceIntelligence = {
  segments: [
    { name: 'Tech Decision Makers', percentage: 35, interest: 'Product features, ROI, integrations', engagement: 4.8, growth: '+12%' },
    { name: 'Creative Professionals', percentage: 28, interest: 'Design tools, workflow tips, inspiration', engagement: 5.2, growth: '+18%' },
    { name: 'Small Business Owners', percentage: 22, interest: 'Pricing, ease-of-use, support', engagement: 3.9, growth: '+7%' },
    { name: 'Industry Analysts', percentage: 15, interest: 'Market trends, comparisons, data', engagement: 2.4, growth: '+3%' },
  ],
  contentTypePerformance: [
    { type: 'Video Tutorials', engagement: 5.8, posts: 12, avgReach: 4200, trend: 'up' },
    { type: 'Carousel Posts', engagement: 4.5, posts: 18, avgReach: 3600, trend: 'up' },
    { type: 'Case Studies', engagement: 3.9, posts: 8, avgReach: 2800, trend: 'stable' },
    { type: 'Quick Tips', engagement: 3.2, posts: 24, avgReach: 2100, trend: 'down' },
    { type: 'Polls & Questions', engagement: 6.1, posts: 10, avgReach: 3100, trend: 'up' },
    { type: 'Behind the Scenes', engagement: 4.0, posts: 6, avgReach: 1900, trend: 'stable' },
  ],
  peakEngagement: {
    days: [
      { day: 'Mon', score: 72 },
      { day: 'Tue', score: 85 },
      { day: 'Wed', score: 91 },
      { day: 'Thu', score: 78 },
      { day: 'Fri', score: 64 },
      { day: 'Sat', score: 45 },
      { day: 'Sun', score: 52 },
    ],
    hours: [
      { hour: '6-9 AM', score: 45 },
      { hour: '9-12 PM', score: 88 },
      { hour: '12-2 PM', score: 72 },
      { hour: '2-5 PM', score: 65 },
      { hour: '5-8 PM', score: 82 },
      { hour: '8-11 PM', score: 58 },
    ],
  },
  optimizationSignals: [
    { signal: 'Video content gets 2.3x more saves than static posts', priority: 'high' },
    { signal: 'Tuesday-Wednesday posts generate 34% more engagement', priority: 'high' },
    { signal: 'Carousel posts with 5+ slides have 40% longer dwell time', priority: 'medium' },
    { signal: 'Posts with CTA in first line get 18% more clicks', priority: 'medium' },
    { signal: 'Stories engagement drops 22% after 4pm on weekdays', priority: 'low' },
  ],
};

export const competitorBenchmark = {
  competitors: [
    { name: 'Competitor A', followers: 18500, engagement: 3.2, postsPerWeek: 6, avgReach: 5200, visibility: 78 },
    { name: 'Competitor B', followers: 9800, engagement: 4.5, postsPerWeek: 4, avgReach: 3800, visibility: 62 },
    { name: 'Competitor C', followers: 22100, engagement: 2.1, postsPerWeek: 8, avgReach: 6100, visibility: 85 },
  ],
  brandMetrics: { followers: 12400, engagement: 4.2, postsPerWeek: 5, avgReach: 4200, visibility: 71 },
  gapAnalysis: [
    { area: 'Post Frequency', brand: 5, competitorAvg: 6, gap: '-17%', priority: 'medium' },
    { area: 'Video Content', brand: 15, competitorAvg: 35, gap: '-57%', priority: 'high' },
    { area: 'Engagement Rate', brand: 4.2, competitorAvg: 3.3, gap: '+27%', priority: 'strength' },
    { area: 'Hashtag Strategy', brand: 3, competitorAvg: 8, gap: '-62%', priority: 'high' },
    { area: 'User-Generated Content', brand: 2, competitorAvg: 6, gap: '-67%', priority: 'medium' },
  ],
  contentRecommendations: [
    'Increase video output to match Competitor C\'s cadence',
    'Launch UGC campaign to close the 67% gap with competitors',
    'Expand hashtag research — current usage is 62% below benchmark',
    'Maintain engagement rate strength while scaling volume',
    'Adopt Competitor B\'s carousel format strategy for higher saves',
  ],
};

export const contentCalendar = [
  {
    week: 1,
    items: [
      { day: 'Mon, Mar 2', postingDate: 'Mar 2, 2026', platforms: ['LinkedIn'], format: 'Article', theme: 'Industry Trends', pillar: 'Thought Leadership', objective: 'Thought Leadership', hook: 'The biggest shift nobody is talking about...', copy: 'We analyzed 500+ projects this quarter and found one pattern that separated winners from everyone else.', caption: 'What do all top-performing teams have in common? A data-first approach to decision making.', hashtags: ['ThoughtLeadership','IndustryTrends','DataDriven','BusinessGrowth','MarketingStrategy'], engagementIntent: 'Comments & shares' },
      { day: 'Wed, Mar 4', postingDate: 'Mar 4, 2026', platforms: ['Instagram', 'Facebook'], format: 'Carousel', theme: 'Product Tips', pillar: 'Education', objective: 'Education', hook: '5 mistakes killing your productivity', copy: 'Swipe to see the 5 workflow mistakes costing teams 10+ hours every week.', caption: 'Which one are you guilty of? Tell us below!', hashtags: ['ProductivityTips','WorkflowHacks','TeamEfficiency','SaaS','WorkSmarter'], engagementIntent: 'Saves & comments' },
      { day: 'Fri, Mar 6', postingDate: 'Mar 6, 2026', platforms: ['Twitter'], format: 'Thread', theme: 'Behind the Scenes', pillar: 'Brand Storytelling', objective: 'Brand Storytelling', hook: 'How we shipped 3 features in 1 sprint', copy: 'Thread: Here\'s the exact process we used to ship 3 major features in a single 2-week sprint.', caption: 'What would you add to this process?', hashtags: ['StartupLife','Agile','ProductDevelopment','TechThread','BuildInPublic'], engagementIntent: 'Retweets & replies' },
    ],
  },
  {
    week: 2,
    items: [
      { day: 'Tue, Mar 10', postingDate: 'Mar 10, 2026', platforms: ['YouTube'], format: 'Tutorial', theme: 'How-To Guide', pillar: 'Education', objective: 'Education', hook: 'Master this feature in 8 minutes', copy: 'In this step-by-step tutorial, we walk through the advanced workflow automation feature.', caption: 'Subscribe for more tutorials every Saturday!', hashtags: ['YouTubeTutorial','HowTo','SaaSTutorial','WorkflowAutomation','ProductDemo'], engagementIntent: 'Subscribes & likes' },
      { day: 'Thu, Mar 12', postingDate: 'Mar 12, 2026', platforms: ['Instagram', 'Facebook'], format: 'Reel', theme: 'Quick Tips', pillar: 'Education', objective: 'Awareness', hook: 'This one trick changed everything', copy: 'POV: You discover the shortcut that saves 2 hours every single day.', caption: 'Tag someone who needs to see this!', hashtags: ['QuickTips','ProductivityHack','TimeSaver','InstagramReels','ViralTips'], engagementIntent: 'Shares & tags' },
      { day: 'Fri, Mar 13', postingDate: 'Mar 13, 2026', platforms: ['LinkedIn', 'Twitter'], format: 'Poll', theme: 'Community Engagement', pillar: 'Trust', objective: 'Engagement', hook: 'We asked 1,000 professionals one question', copy: 'Poll: What\'s the #1 thing holding your team back from peak productivity?', caption: 'Results and insights coming Monday. Vote now!', hashtags: ['LinkedInPoll','CommunityEngagement','ProfessionalGrowth','TeamProductivity','PollTime'], engagementIntent: 'Votes & comments' },
    ],
  },
  {
    week: 3,
    items: [
      { day: 'Mon, Mar 16', postingDate: 'Mar 16, 2026', platforms: ['Twitter', 'LinkedIn'], format: 'Single Tweet', theme: 'Product Launch', pillar: 'Trust', objective: 'Conversion', hook: 'It\'s finally here', copy: 'After 6 months of development, Feature X is now live for all users. Here\'s what it does:', caption: 'Try it free for 14 days. Link in bio.', hashtags: ['ProductLaunch','NewFeature','SaaSUpdate','TryItFree','TechLaunch'], engagementIntent: 'Clicks & replies' },
      { day: 'Wed, Mar 18', postingDate: 'Mar 18, 2026', platforms: ['LinkedIn'], format: 'Article', theme: 'Case Study', pillar: 'Trust', objective: 'Social Proof', hook: 'How Client Y increased output by 340%', copy: 'This case study breaks down the exact strategy that helped a 12-person team 3x their output.', caption: 'Full breakdown in the article. What result surprised you most?', hashtags: ['CaseStudy','ClientWin','SuccessStory','BusinessGrowth','ROI'], engagementIntent: 'Comments & shares' },
      { day: 'Fri, Mar 20', postingDate: 'Mar 20, 2026', platforms: ['Instagram', 'Facebook'], format: 'Story Series', theme: 'FAQ', pillar: 'Retention', objective: 'Support', hook: 'Your top 3 questions, answered', copy: 'We collected the most asked questions this week and answered them all in 60 seconds each.', caption: 'Got more questions? Drop them below!', hashtags: ['FAQ','InstagramStories','QandA','CustomerSupport','BehindTheScenes'], engagementIntent: 'Replies & DMs' },
    ],
  },
  {
    week: 4,
    items: [
      { day: 'Tue, Mar 24', postingDate: 'Mar 24, 2026', platforms: ['Facebook', 'LinkedIn'], format: 'Event', theme: 'Community Building', pillar: 'Retention', objective: 'Retention', hook: 'Join us live this Thursday', copy: 'We\'re hosting a live Q&A session with our product team. Bring your toughest questions.', caption: 'Set a reminder — link in comments.', hashtags: ['LiveQandA','CommunityEvent','LinkedInLive','FacebookLive','JoinUs'], engagementIntent: 'Event responses' },
      { day: 'Thu, Mar 26', postingDate: 'Mar 26, 2026', platforms: ['LinkedIn', 'Twitter'], format: 'Document', theme: 'Resource Download', pillar: 'Lead Generation', objective: 'Lead Gen', hook: 'Free template: The 2025 planning framework', copy: 'We built the exact framework our team uses for quarterly planning. Grab it for free.', caption: 'Download link in first comment. No email required.', hashtags: ['FreeTemplate','LeadGeneration','ResourceDownload','PlanningFramework','QuarterlyPlanning'], engagementIntent: 'Downloads & comments' },
      { day: 'Sat, Mar 28', postingDate: 'Mar 28, 2026', platforms: ['YouTube'], format: 'Interview', theme: 'Thought Leadership', pillar: 'Thought Leadership', objective: 'Authority', hook: 'We sat down with a $10M founder', copy: 'In this 20-minute interview, the founder of Startup Z reveals the one metric that matters.', caption: 'Who should we interview next? Let us know!', hashtags: ['FounderInterview','ThoughtLeadership','YouTubeInterview','StartupStory','BusinessAdvice'], engagementIntent: 'Comments & subscribes' },
    ],
  },
];

export const monthlyThemes = [
  { week: 1, theme: 'Innovation & Trends', focus: 'Position brand as forward-thinking', pillar: 'Thought Leadership' },
  { week: 2, theme: 'Product Education', focus: 'Deep-dive into key features', pillar: 'Education' },
  { week: 3, theme: 'Social Proof', focus: 'Showcase customer wins and case studies', pillar: 'Trust' },
  { week: 4, theme: 'Community & Culture', focus: 'Engage audience and build belonging', pillar: 'Retention' },
];

export const audienceContentIntelligence = {
  platforms: [
    { id: 'instagram', name: 'Instagram', icon: 'ri-instagram-line' },
    { id: 'linkedin', name: 'LinkedIn', icon: 'ri-linkedin-box-line' },
    { id: 'twitter', name: 'Twitter / X', icon: 'ri-twitter-x-line' },
    { id: 'youtube', name: 'YouTube', icon: 'ri-youtube-line' },
    { id: 'facebook', name: 'Facebook', icon: 'ri-facebook-circle-line' },
  ],

  audienceBehaviorClustering: {
    instagram: [
      { segment: 'Informational Seekers', percentage: 28, engagement: 4.2, trend: 'up', description: 'Users searching for tips, how-tos, and industry knowledge' },
      { segment: 'Product Explorers', percentage: 35, engagement: 6.8, trend: 'up', description: 'Users actively exploring product features and use cases' },
      { segment: 'Brand Followers', percentage: 22, engagement: 3.1, trend: 'flat', description: 'Loyal audience engaging with brand story and culture content' },
      { segment: 'Passive Viewers', percentage: 15, engagement: 1.2, trend: 'down', description: 'Scroll-heavy users with low interaction, high impression count' },
    ],
    linkedin: [
      { segment: 'Informational Seekers', percentage: 42, engagement: 5.8, trend: 'up', description: 'Professionals seeking thought leadership and industry insights' },
      { segment: 'Product Explorers', percentage: 24, engagement: 3.9, trend: 'flat', description: 'Decision-makers evaluating solutions for their organization' },
      { segment: 'Brand Followers', percentage: 21, engagement: 2.8, trend: 'up', description: 'Industry peers following company updates and milestones' },
      { segment: 'Passive Viewers', percentage: 13, engagement: 1.5, trend: 'down', description: 'Feed scrollers with minimal comment or share activity' },
    ],
    twitter: [
      { segment: 'Informational Seekers', percentage: 31, engagement: 3.2, trend: 'flat', description: 'Users looking for quick takes, news, and trending topics' },
      { segment: 'Product Explorers', percentage: 19, engagement: 2.1, trend: 'down', description: 'Tech-savvy users clicking through to product pages' },
      { segment: 'Brand Followers', percentage: 26, engagement: 4.5, trend: 'up', description: 'Engaged community replying to threads and polls' },
      { segment: 'Passive Viewers', percentage: 24, engagement: 0.8, trend: 'down', description: 'Lurkers reading threads without interaction' },
    ],
    youtube: [
      { segment: 'Informational Seekers', percentage: 38, engagement: 5.1, trend: 'up', description: 'Tutorial hunters looking for in-depth walkthroughs' },
      { segment: 'Product Explorers', percentage: 29, engagement: 4.8, trend: 'up', description: 'Users watching product demos and comparison videos' },
      { segment: 'Brand Followers', percentage: 18, engagement: 3.5, trend: 'flat', description: 'Subscribers engaging with behind-the-scenes and vlogs' },
      { segment: 'Passive Viewers', percentage: 15, engagement: 1.8, trend: 'down', description: 'Background watchers with low comment rate' },
    ],
    facebook: [
      { segment: 'Informational Seekers', percentage: 22, engagement: 1.8, trend: 'down', description: 'Users seeking community advice and group discussions' },
      { segment: 'Product Explorers', percentage: 18, engagement: 1.5, trend: 'down', description: 'Older demographic clicking event and offer posts' },
      { segment: 'Brand Followers', percentage: 35, engagement: 2.2, trend: 'flat', description: 'Community members engaging with event and group content' },
      { segment: 'Passive Viewers', percentage: 25, engagement: 0.6, trend: 'down', description: 'Low-engagement scrollers in news feed' },
    ],
  },

  sentimentIntelligence: {
    instagram: [
      { type: 'Positive Feedback', percentage: 42, volume: 1240, trend: 'up', examples: ['Love this feature!', 'Great tips, saving this'] },
      { type: 'Queries', percentage: 28, volume: 826, trend: 'up', examples: ['How do I get started?', 'Is this available on mobile?'] },
      { type: 'Complaints', percentage: 18, volume: 531, trend: 'flat', examples: ['Too expensive for small teams', 'Missing integration with X'] },
      { type: 'Intent Signals', percentage: 12, volume: 354, trend: 'up', examples: ['Where can I sign up?', 'Pricing page link?'] },
    ],
    linkedin: [
      { type: 'Positive Feedback', percentage: 38, volume: 892, trend: 'up', examples: ['Solid insights, thanks for sharing', 'Well researched article'] },
      { type: 'Queries', percentage: 31, volume: 727, trend: 'up', examples: ['Can this scale to enterprise?', 'What about compliance?'] },
      { type: 'Complaints', percentage: 16, volume: 375, trend: 'flat', examples: ['Another SaaS tool, market is saturated', 'Overhyped in my opinion'] },
      { type: 'Intent Signals', percentage: 15, volume: 352, trend: 'up', examples: ['DMing you for a demo', 'Adding to my evaluation list'] },
    ],
    twitter: [
      { type: 'Positive Feedback', percentage: 35, volume: 1560, trend: 'flat', examples: ['This thread is fire', 'Following for more'] },
      { type: 'Queries', percentage: 22, volume: 980, trend: 'up', examples: ['What stack are you using?', 'Is there a free tier?'] },
      { type: 'Complaints', percentage: 24, volume: 1070, trend: 'up', examples: ['Too many tweets about this', 'VC hype machine'] },
      { type: 'Intent Signals', percentage: 19, volume: 847, trend: 'up', examples: ['Just signed up, lets go', 'Landing page looks clean'] },
    ],
    youtube: [
      { type: 'Positive Feedback', percentage: 48, volume: 680, trend: 'up', examples: ['Best tutorial on this topic', 'Subscribed after this'] },
      { type: 'Queries', percentage: 26, volume: 368, trend: 'up', examples: ['Can you cover advanced mode?', 'What mic do you use?'] },
      { type: 'Complaints', percentage: 14, volume: 198, trend: 'flat', examples: ['Video too long', 'Need timestamps'] },
      { type: 'Intent Signals', percentage: 12, volume: 170, trend: 'up', examples: ['Link to the tool in description?', 'Just started my trial'] },
    ],
    facebook: [
      { type: 'Positive Feedback', percentage: 36, volume: 420, trend: 'flat', examples: ['Thanks for hosting this', 'Great community'] },
      { type: 'Queries', percentage: 24, volume: 280, trend: 'down', examples: ['When is the next live session?', 'How to join the group?'] },
      { type: 'Complaints', percentage: 22, volume: 257, trend: 'up', examples: ['Too many promotional posts', 'Feed is cluttered'] },
      { type: 'Intent Signals', percentage: 18, volume: 210, trend: 'flat', examples: ['Interested in the workshop', 'Sent a message about pricing'] },
    ],
  },

  contentTypePerformance: {
    instagram: [
      { type: 'Reel', score: 9.2, engagement: 8.4, reach: 45200, bestFor: 'Product Explorers' },
      { type: 'Carousel', score: 8.5, engagement: 6.2, reach: 32100, bestFor: 'Informational Seekers' },
      { type: 'Story', score: 6.8, engagement: 4.1, reach: 18900, bestFor: 'Brand Followers' },
      { type: 'Static Image', score: 4.2, engagement: 2.8, reach: 12400, bestFor: 'Passive Viewers' },
      { type: 'Live', score: 7.1, engagement: 5.5, reach: 15600, bestFor: 'Brand Followers' },
    ],
    linkedin: [
      { type: 'Article', score: 8.8, engagement: 5.8, reach: 28400, bestFor: 'Informational Seekers' },
      { type: 'Document Post', score: 8.2, engagement: 5.2, reach: 22100, bestFor: 'Informational Seekers' },
      { type: 'Poll', score: 9.1, engagement: 8.5, reach: 31200, bestFor: 'Brand Followers' },
      { type: 'Text Post', score: 6.5, engagement: 3.9, reach: 18200, bestFor: 'Product Explorers' },
      { type: 'Video', score: 7.8, engagement: 4.8, reach: 24500, bestFor: 'Product Explorers' },
    ],
    twitter: [
      { type: 'Thread', score: 8.6, engagement: 4.5, reach: 19800, bestFor: 'Informational Seekers' },
      { type: 'Single Tweet', score: 5.2, engagement: 2.1, reach: 8900, bestFor: 'Passive Viewers' },
      { type: 'Poll', score: 7.9, engagement: 6.1, reach: 15200, bestFor: 'Brand Followers' },
      { type: 'Space', score: 6.4, engagement: 3.8, reach: 11200, bestFor: 'Brand Followers' },
      { type: 'Video', score: 7.1, engagement: 3.5, reach: 13400, bestFor: 'Product Explorers' },
    ],
    youtube: [
      { type: 'Short', score: 9.4, engagement: 8.2, reach: 56700, bestFor: 'Informational Seekers' },
      { type: 'Tutorial', score: 8.7, engagement: 6.8, reach: 42100, bestFor: 'Informational Seekers' },
      { type: 'Product Demo', score: 8.1, engagement: 5.9, reach: 38400, bestFor: 'Product Explorers' },
      { type: 'Interview', score: 7.3, engagement: 4.5, reach: 28900, bestFor: 'Brand Followers' },
      { type: 'Vlog', score: 5.8, engagement: 3.2, reach: 19800, bestFor: 'Passive Viewers' },
    ],
    facebook: [
      { type: 'Event', score: 7.2, engagement: 4.8, reach: 12400, bestFor: 'Brand Followers' },
      { type: 'Video', score: 5.8, engagement: 3.1, reach: 8900, bestFor: 'Product Explorers' },
      { type: 'Group Post', score: 6.4, engagement: 3.5, reach: 10200, bestFor: 'Informational Seekers' },
      { type: 'Image', score: 4.1, engagement: 2.2, reach: 6700, bestFor: 'Passive Viewers' },
      { type: 'Live', score: 6.8, engagement: 4.2, reach: 11500, bestFor: 'Brand Followers' },
    ],
  },

  contentThemePerformance: {
    instagram: [
      { theme: 'Quick Tips', score: 8.6, engagement: 6.8, posts: 14, bestType: 'Reel' },
      { theme: 'Behind the Scenes', score: 7.9, engagement: 5.2, posts: 8, bestType: 'Story' },
      { theme: 'Product Showcase', score: 8.2, engagement: 6.1, posts: 10, bestType: 'Carousel' },
      { theme: 'Testimonial', score: 7.4, engagement: 4.8, posts: 5, bestType: 'Carousel' },
      { theme: 'Educational', score: 8.8, engagement: 7.2, posts: 12, bestType: 'Carousel' },
    ],
    linkedin: [
      { theme: 'Case Study', score: 9.0, engagement: 6.8, posts: 6, bestType: 'Article' },
      { theme: 'Educational', score: 8.7, engagement: 6.2, posts: 10, bestType: 'Document Post' },
      { theme: 'Industry Trends', score: 8.5, engagement: 5.9, posts: 8, bestType: 'Article' },
      { theme: 'Thought Leadership', score: 8.3, engagement: 5.5, posts: 7, bestType: 'Text Post' },
      { theme: 'Testimonial', score: 7.1, engagement: 4.2, posts: 4, bestType: 'Document Post' },
    ],
    twitter: [
      { theme: 'Educational', score: 8.4, engagement: 4.8, posts: 12, bestType: 'Thread' },
      { theme: 'Behind the Scenes', score: 7.6, engagement: 4.1, posts: 8, bestType: 'Thread' },
      { theme: 'Hot Takes', score: 8.0, engagement: 5.2, posts: 10, bestType: 'Single Tweet' },
      { theme: 'Product Updates', score: 6.8, engagement: 3.5, posts: 6, bestType: 'Thread' },
      { theme: 'Community Poll', score: 7.9, engagement: 5.8, posts: 5, bestType: 'Poll' },
    ],
    youtube: [
      { theme: 'How-To Guide', score: 9.1, engagement: 7.8, posts: 8, bestType: 'Tutorial' },
      { theme: 'Case Study', score: 8.3, engagement: 6.1, posts: 4, bestType: 'Tutorial' },
      { theme: 'Product Demo', score: 8.5, engagement: 6.5, posts: 5, bestType: 'Product Demo' },
      { theme: 'Interview', score: 7.5, engagement: 4.8, posts: 3, bestType: 'Interview' },
      { theme: 'Industry Trends', score: 7.8, engagement: 5.2, posts: 4, bestType: 'Short' },
    ],
    facebook: [
      { theme: 'Community Events', score: 7.2, engagement: 4.5, posts: 4, bestType: 'Event' },
      { theme: 'Educational', score: 6.4, engagement: 3.2, posts: 5, bestType: 'Group Post' },
      { theme: 'Product Updates', score: 5.8, engagement: 2.8, posts: 3, bestType: 'Video' },
      { theme: 'User Stories', score: 6.9, engagement: 3.8, posts: 4, bestType: 'Group Post' },
      { theme: 'FAQ', score: 6.2, engagement: 3.5, posts: 3, bestType: 'Group Post' },
    ],
  },
};

export interface AudienceBehaviorCluster {
  segment: string;
  percentage: number;
  engagement: number;
  trend: 'up' | 'down' | 'flat';
  description: string;
}

export interface SentimentCluster {
  type: string;
  percentage: number;
  volume: number;
  trend: 'up' | 'down' | 'flat';
  examples: string[];
}

export interface ContentTypePerf {
  type: string;
  score: number;
  engagement: number;
  reach: number;
  bestFor: string;
}

export interface ContentThemePerf {
  theme: string;
  score: number;
  engagement: number;
  posts: number;
  bestType: string;
}